// extracted by mini-css-extract-plugin
export var container = "_gv-1";
export var cornerButtonContainer = "_gv-6";
export var disabled = "_gv-2";
export var dragActive = "_gv-3";
export var fileContainer = "_gv-5";
export var hiddenInput = "_gv-4";
export var widthContainer = "_gv-0";